@if (label(); as label) {
    <div class="pb-2">
        <app-label [required]="required()">{{ label }}</app-label>
    </div>
}
@if (hint(); as hint) {
    <div class="pb-2">
        <app-hint>{{ hint }}</app-hint>
    </div>
}
<label class="theme-border" [class.active]="value()" [attr.data-size]="currentSize()" [attr.data-theme]="theme()">
    <input type="checkbox" class="hidden" [(ngModel)]="value" (change)="handleChange($event)" [disabled]="disabled()" />
    <div [attr.data-size]="currentSize()" class="circle" [class.active]="value()"></div>
</label>
